



















import { Component, Prop, Vue } from "vue-property-decorator";
import DashboardDataCard from "./DashboardDataCard.vue";
import { IDashboardData } from "@/types/Dashboard.model";
import { MyOptions } from "@/charts/graphData";

@Component({
  components: {
    DashboardDataCard,
  },
})
export default class DashboardProfitCard extends Vue {
  @Prop() public dashboardData!: IDashboardData;
  @Prop() public profitKey!: string;
  @Prop() public profitData!: number;
  @Prop() public keyIndex!: string;
  @Prop() public isTTC!: boolean;
  @Prop() public myOptions!: MyOptions;
  @Prop({ default: "" }) public styleClass!: string;
  @Prop({ default: () => ({}) }) public styleObject!: object;
  @Prop({ default: "" }) public backgroundColor!: string;

  get computedStyle(): string {
    const baseStyle = "height: 275px";
    const bgStyle = this.backgroundColor ? `background-color: ${this.backgroundColor}` : "";
    const customStyle = this.styleObject ?
      Object.entries(this.styleObject).map(([key, value]) => `${key}: ${value}`).join("; ") : "";

    return [baseStyle, bgStyle, customStyle].filter(Boolean).join("; ");
  }
}
